import { gql } from '@apollo/client';

export const GET_USER_LIST = gql`
  query GetUserList($filter: UserListFilterInput) {
    getUserList(filter: $filter) {
      success
      message
      users {
        id
        name
        userName
        email
        contact
        isActive
        isAlive
        isMain
        createdAt
        parentId
        parent {
          id
          name
          userName
        }
        serviceProvider {
          id
          name
          userName
          contact
        }
        role {
          id
          name
          description
          hidden
          isInternal
        }
      }
      total
      page
      pageSize
    }
  }
`;

export const GET_ROLE_LIST = gql`
  query GetRoleList {
    getRoleList {
      success
      message
      roles {
        id
        name
        description
        hidden
        isInternal
      }
    }
  }
`;

export const UPDATE_USER_ROLE = gql`
  mutation UpdateUserRole($input: UpdateUserRoleInput!) {
    updateUserRole(input: $input) {
      success
      message
      user {
        id
        name
        userName
        email
        contact
        isActive
        isAlive
        isMain
        createdAt
        parentId
        parent {
          id
          name
          userName
        }
        serviceProvider {
          id
          name
          userName
          contact
        }
        role {
          id
          name
          description
          hidden
          isInternal
        }
      }
    }
  }
`;

export const UPDATE_USER_STATUS = gql`
  mutation UpdateUserStatus($input: UpdateUserStatusInput!) {
    updateUserStatus(input: $input) {
      success
      message
      user {
        id
        name
        userName
        email
        contact
        isActive
        isAlive
        isMain
        createdAt
        parentId
        parent {
          id
          name
          userName
        }
        serviceProvider {
          id
          name
          userName
          contact
        }
        role {
          id
          name
          description
          hidden
          isInternal
        }
      }
    }
  }
`;

export const UPDATE_USER_IS_ALIVE = gql`
  mutation UpdateUserIsAlive($input: UpdateUserIsAliveInput!) {
    updateUserIsAlive(input: $input) {
      success
      message
      user {
        id
        name
        userName
        email
        contact
        isActive
        isAlive
        isMain
        createdAt
        parentId
        parent {
          id
          name
          userName
        }
        serviceProvider {
          id
          name
          userName
          contact
        }
        role {
          id
          name
          description
          hidden
          isInternal
        }
      }
    }
  }
`;

export const RESET_USER_PASSWORD = gql`
  mutation ResetUserPassword($input: ResetUserPasswordInput!) {
    resetUserPassword(input: $input) {
      success
      message
      newPassword
    }
  }
`;

export const UPDATE_USER_EMAIL = gql`
  mutation UpdateUserEmail($input: UpdateUserEmailInput!) {
    updateUserEmail(input: $input) {
      success
      message
      user {
        id
        name
        userName
        email
        contact
        isActive
        isAlive
        isMain
        createdAt
        parentId
        parent {
          id
          name
          userName
        }
        serviceProvider {
          id
          name
          userName
          contact
        }
        role {
          id
          name
          description
          hidden
          isInternal
        }
      }
    }
  }
`;

export const GET_SERVICE_BY_DROPDOWN = gql`
  query GetServiceByDropdown {
    getServiceByDropdown {
      key
      value
      label
      description
    }
  }
`;

export const UPDATE_USER_SERVICE_PROVIDER = gql`
  mutation UpdateUserServiceProvider($input: UpdateUserServiceProviderInput!) {
    updateUserServiceProvider(input: $input) {
      success
      message
      user {
        id
        name
        userName
        email
        contact
        isActive
        isAlive
        isMain
        createdAt
        parentId
        parent {
          id
          name
          userName
        }
        serviceProvider {
          id
          name
          userName
          contact
        }
        role {
          id
          name
          description
          hidden
          isInternal
        }
      }
    }
  }
`;